<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.bizCancel.form.email')" prop="email">
        <a-input v-model="form.email" disabled :placeholder="$t('views.bizCancel.form.emailPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.bizCancel.form.reason')" prop="reason" disabled>
        <a-input v-model="form.reason" disabled type="textarea" :placeholder="$t('views.bizCancel.form.reasonPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.bizCancel.form.status')" prop="status" >
        <a-select :placeholder="$t('views.bizCancel.form.statusPlaceholder')" v-model="form.status">
          <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="parseInt(d.value)" >{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.bizCancel.form.failReason')" prop="failReason" >
        <a-input v-model="form.failReason" type="textarea" :placeholder="$t('views.bizCancel.form.failReasonPlaceholder')" />
      </a-form-model-item>
      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.bizCancel.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.bizCancel.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCancel, addCancel, updateCancel } from '@/api/biz/cancel'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        email: null,
        reason: null,
        status: 0,
        failReason: null,
        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules () {
      return {
        reason: [
          { required: true, message: this.$t('views.bizCancel.rule.reasonRequired'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('views.bizCancel.rule.statusRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        email: null,
        reason: null,
        status: 0,
        failReason: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.bizCancel.title.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCancel({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('views.bizCancel.title.audit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCancel(this.form).then(response => {
              this.$message.success(
                this.$t('views.bizCancel.msg.updateOk'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCancel(this.form).then(response => {
              this.$message.success(
                this.$t('views.bizCancel.msg.addOk'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
